import React from "react";

const Footer = () =>(
    <footer className="bg-literary-navy text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {/* Brand Column */}
                <div className="lg:col-span-2">
                    <div className="flex items-center space-x-3 mb-6">
                        <div>
                            <h3 className="font-headline text-2xl font-bold text-historical-gold">
                                Rosa Maria Cifuentes
                            </h3>
                        </div>
                    </div>

                    <p className="font-body text-gray-300 leading-relaxed mb-6 max-w-md">
                        El rincón digital oficial de la escritora más vendida del Perú y una de las más importantes de Lationamérica.
                        Explora su amplia colección y las disciplinas que ofrece para sus seguidores, lectores y pacientes.
                    </p>
                </div>

                <div className="lg:col-span-2">
                    <h4 className="font-headline text-lg font-semibold text-historical-gold mb-4">
                        Contacto
                    </h4>
                    <ul className="space-y-2">
                        <li className="font-body text-gray-300">resurge.consultora@gmail.com</li>
                        <li className="font-body text-gray-300">Manager para Perú y Lationamérica (Thany Meza): +51 976 310 264</li>
                        <li className="font-body text-gray-300">Manager para Europa (Luis Acosta): +34 610 06 25 08</li>
                        <li className="font-body text-gray-300">Talleres y Capacitaciones: +51 999 202 119</li>
                    </ul>
                </div>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center">
                <p className="font-body text-gray-400 text-sm">
                    © {new Date()?.getFullYear()} Rosa Maria  Cifuentes. Todos los derechos reservados.
                </p>
            </div>
        </div>
    </footer>
)
export default Footer;